import axios from 'axios';
import Vue from "vue";
export default {

    state: {},
    mutations: {},

    getters: {},
    actions: {
        async GetVoucher(context, params) {
            
            const response = await axios.post(Vue.prototype.$config.authenticationBaseAddress + "HotelRoom/GetVoucherById", params);

            return response.data.data;
        },
        async GetVoucherHotelFlight(context, params) {

            const response = await axios.post(Vue.prototype.$config.unauthorizedHotelFlight + "BOOKING/VOUCHERBYRESERVENUMBER", params);

            return response.data.data;
        },
    },
};
